import React, { useEffect, useState } from 'react'
import { createRoot } from 'react-dom/client'
import Header from './components/Header'
import Hero from './components/Hero'
import Projects from './components/Projects'
import Experience from './components/Experience'
import Skills from './components/Skills'
import About from './components/About'
import Education from './components/Education'
import Contact from './components/Contact'
import Footer from './components/Footer'
import { profile } from './data/profile'
import {
  nav,
  ui,
  projects,
  experience,
  skills,
  education,
  professionalInterests
} from './data/content'
import './styles.css'
function App() {
  const [lang, setLang] = useState(() =>
    navigator.language?.toLowerCase().startsWith('es') ? 'es' : 'en'
  )
  const t = ui[lang]
  useEffect(() => {
    document.documentElement.lang = lang
  }, [lang])
  const go = (id) =>
    document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' })
  return (
    <>
      <Header lang={lang} setLang={setLang} t={nav[lang]} go={go} />
      <main id="top">
        <Hero profile={profile} t={t} go={go} lang={lang} />
        <div className="tech-strip">
          <div className="container tech">
            <span className="tech-label">{t.technologies}</span>
            {[
              'React',
              'Flutter',
              'PHP',
              'Symfony',
              'CodeIgniter',
              'Angular',
              'PostgreSQL',
              'MySQL',
              'SQL Server',
              '.NET',
              'Git'
            ].map((x) => (
              <span key={x}>{x}</span>
            ))}
          </div>
        </div>
        <Projects projects={projects} lang={lang} t={t} />
        <Experience items={experience} lang={lang} t={t} />
        <Skills skills={skills} lang={lang} t={t} />
        <About
          profile={profile}
          lang={lang}
          t={t}
          interests={professionalInterests}
        />
        <Education education={education} lang={lang} t={t} />
        <Contact profile={profile} t={t} lang={lang} />
      </main>
      <Footer profile={profile} lang={lang} />
    </>
  )
}
createRoot(document.getElementById('root')).render(<App />)
